/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import ICommonTranslationDropdown from '../../types/common/dropdown';

const initTranslationDropdown: ICommonTranslationDropdown = {
    cancelBtn: '',
    closeBtn: '',
    okBtn: '',
    placeholder: '',
};

export default initTranslationDropdown;
